var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2780_14227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.876 6C14.7184 3.351 12.075 1.5 9 1.5C5.925 1.5 3.28125 3.351 2.124 6",
    stroke: "#34C759",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 5.25C8.28659 5.94751 7.71999 6.78075 7.33357 7.70062C6.94715 8.62049 6.74873 9.60839 6.75 10.6061C6.75 10.7936 6.75687 10.9796 6.77062 11.1641C7.47787 11.861 8.03925 12.6917 8.42201 13.6078C8.80478 14.5239 9.00126 15.5071 9 16.5C8.99869 15.5071 9.19515 14.5238 9.57791 13.6076C9.96068 12.6914 10.5221 11.8606 11.2294 11.1638C11.2431 10.9798 11.25 10.7939 11.25 10.6061C11.2513 9.60839 11.0528 8.62049 10.6664 7.70062C10.28 6.78075 9.71341 5.94751 9 5.25Z",
    stroke: "#34C759",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 9.00001C1.5 13.1423 4.85775 16.5 9 16.5C9.00131 15.5071 8.80485 14.5238 8.42209 13.6076C8.03932 12.6914 7.47791 11.8607 6.77063 11.1638C5.36814 9.77522 3.47358 8.99744 1.5 9.00001Z",
    stroke: "#34C759",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 9.00001C16.5 13.1423 13.1422 16.5 9 16.5C8.99869 15.5071 9.19515 14.5238 9.57791 13.6076C9.96068 12.6914 10.5221 11.8607 11.2294 11.1638C12.6319 9.77522 14.5264 8.99744 16.5 9.00001Z",
    stroke: "#34C759",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2780_14227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreen);
export default __webpack_public_path__ + "static/media/green.6fdbaade4e1890f59cfa84323ca9b598.svg";
export { ForwardRef as ReactComponent };